/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Common API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { PostV1RsaKeyParams, RsaVO } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getRsaKey
 */
export const postV1RsaKey = (
  params?: MaybeRef<PostV1RsaKeyParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<RsaVO>(
    { url: `/api/v1/rsa-key`, method: 'POST', params: unref(params), signal },
    options,
  );
};

export const getPostV1RsaKeyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1RsaKey>>,
    TError,
    { params?: PostV1RsaKeyParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1RsaKey>>,
  TError,
  { params?: PostV1RsaKeyParams },
  TContext
> => {
  const mutationKey = ['postV1RsaKey'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1RsaKey>>,
    { params?: PostV1RsaKeyParams }
  > = (props) => {
    const { params } = props ?? {};

    return postV1RsaKey(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1RsaKeyMutationResult = NonNullable<Awaited<ReturnType<typeof postV1RsaKey>>>;

export type PostV1RsaKeyMutationError = ErrorType<unknown>;

/**
 * @summary getRsaKey
 */
export const usePostV1RsaKey = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1RsaKey>>,
      TError,
      { params?: PostV1RsaKeyParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV1RsaKey>>,
  TError,
  { params?: PostV1RsaKeyParams },
  TContext
> => {
  const mutationOptions = getPostV1RsaKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
